
import { ReactComponent as Sweden } from "../assets/sweden.svg"

import MapPin from "./MapPin";
import { OFFICES } from "../constants/site";


const Map = ({ className = "" }) => {
  return (
    // Wrappern är exakt lika stor som kartan, så pinnarnas procent-positioner följer kartan
    <div className={`relative ${className}`}>
      <Sweden className="h-full w-auto text-slate-300 dark:text-slate-700" />
      {OFFICES.map((office) => (
        <MapPin
          key={office.name}
          top={office.top}
          right={office.right}
          name={office.name}
          description={[office.street, office.zip]}
          maps={office.maps}
        />
      ))}
    </div>
  );
};

export default Map;
